// Module
var code = `<ai-agents class="flex-auto" language="{{\$ctrl.language}}" ownerIdentity="{{\$ctrl.ownerIdentity}}" settings="{{\$ctrl.settingsSource}}" wsparams="{{\$ctrl.webSocketParams}}" user="{{\$ctrl.user}}"></ai-agents> `;
// Exports
module.exports = code;